import { websitesApi } from '../websitesApi';
import { FetchWebsiteRequest } from '../../../types/endpoints/websitesApi/fetchWebsite/FetchWebsiteRequest';
import { FetchWebsiteResponse } from '../../../types/endpoints/websitesApi/fetchWebsite/FetchWebsiteResponse';
import { FetchWebsitesResponse } from '../../../types/endpoints/websitesApi/fetchWebsites/FetchWebsitesResponse';
import { UpdateWebsiteRequest } from '../../../types/endpoints/websitesApi/updateWebsite/UpdateWebsiteRequest';
import { UpdateWebsiteResponse } from '../../../types/endpoints/websitesApi/updateWebsite/UpdateWebsiteResponse';
import { HTTP_METHODS } from '../../../constants/httpMethods';
import {
  FetchVentureWebsiteResponse,
  TransformedFetchVentureWebsiteResponse
} from '../../../types/endpoints/websitesApi/fetchVentureWebsite/FetchVentureWebsiteResponse';
import { FetchVentureWebsiteRequest } from '../../../types/endpoints/websitesApi/fetchVentureWebsite/FetchVentureWebsiteRequest';

export const websitesApiEndpoints = websitesApi.injectEndpoints({
  endpoints: builder => ({
    /** Fetch websites */
    fetchWebsites: builder.query<FetchWebsitesResponse, void>({
      providesTags: ['Websites'],
      query: () => ({
        url: '/websites'
      })
    }),

    /** Fetch a website */
    fetchWebsite: builder.query<FetchWebsiteResponse, FetchWebsiteRequest>({
      providesTags: ['Website'],
      query: ({ websiteId }) => ({
        url: `/websites/${websiteId}`
      }),
      extraOptions: {
        retryCondition: ({ status }: { status: number }, _: any, options: { attempt: number }) => {
          return status !== 400 && options.attempt < 5;
        }
      }
    }),
    /** Fetch venture website  */
    fetchVentureWebsite: builder.query<
      TransformedFetchVentureWebsiteResponse,
      FetchVentureWebsiteRequest
    >({
      providesTags: ['VentureWebsites'],
      query: ({ ventureId }) => ({
        url: `/ventures/${ventureId}/websites`
      }),
      transformResponse: (
        response: FetchVentureWebsiteResponse
      ): TransformedFetchVentureWebsiteResponse => {
        return response.find(website => website.status === 'active') || response[0];
      }
    }),

    /** Update a website */
    updateWebsite: builder.mutation<UpdateWebsiteResponse, UpdateWebsiteRequest>({
      invalidatesTags: ['Website', 'Websites', 'VentureWebsites'],
      query: ({ websiteId, body }) => ({
        url: `/websites/${websiteId}`,
        method: HTTP_METHODS.PATCH,
        body
      })
    })
  })
});

export const {
  useFetchWebsitesQuery,
  useFetchWebsiteQuery,
  useUpdateWebsiteMutation,
  useFetchVentureWebsiteQuery
} = websitesApiEndpoints;
